import { render, staticRenderFns } from "./StatsCampaignsFilter.vue?vue&type=template&id=a368f8e2&scoped=true&"
import script from "./StatsCampaignsFilter.vue?vue&type=script&lang=js&"
export * from "./StatsCampaignsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a368f8e2",
  null
  
)

export default component.exports